export default "__VITE_ASSET__c35aad8d__"